import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;

export const CITY_URL = APIURL+"/location/cities/";

// CREATE =>  POST: create a new city to the server
export function createCity(city) {
	const result = axios.post(`${CITY_URL}create`, city);
	return result
}

// READ
export function getAllCities() {
  return axios.get(CITY_URL);
}

export function getCitiesByCountryId(countryId) {
  return axios.get(`${CITY_URL}country/${countryId}`);
}

export function getCityById(cityId) {
	const result = axios.get(`${CITY_URL}find/${cityId}`);
	return result;
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findCities(queryParams) {
  const result = axios.post(`${CITY_URL}find`, { queryParams });
  return result;
}

// UPDATE => PUT: update the city on the server
export function updateCity(city) {
  return axios.post(`${CITY_URL}update/${city.id}`, { city });
}

// UPDATE Status
export function updateStatusForCities(ids, status) {
  return axios.post(`${CITY_URL}updateStatusForCities`, {
    ids,
    status
  });
}

// UPDATE single Status
export function updateStatusForCity(id, status) {
  return axios.post(`${CITY_URL}updateStatusForCity`, {
    id,
    status
  });
}

export function createCityByName(name) {
  return axios.post(`${CITY_URL}create`, {
    name
  });
}

export function updateRecordForCity(id,name) {
  return axios.post(`${CITY_URL}updateRecordForCity`, { id, name});
}

// DELETE => delete the city from the server
export function deleteCity(id) {
 return axios.post(`${CITY_URL}delete`, { id });
}

// DELETE Cities by ids
export function deleteCities(ids) {
  return axios.post(`${CITY_URL}deleteCities`, { ids });
}
